define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MScorePrimaryColoursDomain = void 0;
    class MScorePrimaryColoursDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MScorePrimaryColoursDomain.Green, value: "Green" },
                    { key: MScorePrimaryColoursDomain.Orange, value: "Orange" },
                    { key: MScorePrimaryColoursDomain.Red, value: "Red" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MScorePrimaryColoursDomain.Green] = 0;
                this.KeyIndex[MScorePrimaryColoursDomain.Orange] = 1;
                this.KeyIndex[MScorePrimaryColoursDomain.Red] = 2;
                this.ValueIndex = {};
                this.ValueIndex["Green"] = 0;
                this.ValueIndex["Orange"] = 1;
                this.ValueIndex["Red"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MScorePrimaryColoursDomain = MScorePrimaryColoursDomain;
    Object.defineProperty(MScorePrimaryColoursDomain, "Green", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Green"
    });
    Object.defineProperty(MScorePrimaryColoursDomain, "Orange", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Orange"
    });
    Object.defineProperty(MScorePrimaryColoursDomain, "Red", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Red"
    });
    Object.defineProperty(MScorePrimaryColoursDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
